/* eslint-disable react/display-name */

import React, { useMemo } from 'react';
import MaterialTable from 'material-table';
import { useDispatch, useSelector } from 'react-redux';
import { CreatorsAnchors } from '../../../../store/ducks/anchors';

import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';

import { findPermission } from '../../../../services/auth';

import useStyles from './style';

function GridAncorasLojas({ ancoraId, visualize, findAllAncorasLojas, getAncorasLojas }) {
  const classes = useStyles();

  const { filters } = useSelector((state) => state.anchors);
  const anchorFilter = filters.find((x) => x.anchor === 'ancoras-lojas');
  const dispatch = useDispatch();

  const memoizedTable = useMemo(
    () => (
      <MaterialTable
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'Nome',
            field: 'nome',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
            filtering: false,
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            render: (rowData) =>
              !!rowData.ancoraLojaId && (
                <>
                  {!!findPermission(1216, 'Consultar') && (
                    <Link
                      className={classes.buttonVisualize}
                      to={`/app/ancoras-lojas/visualizar/${rowData.ancoraLojaId}`}
                    >
                      <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                    </Link>
                  )}
                  {!!findPermission(1216, 'Alterar') && !visualize && (
                    <Link
                      className={classes.buttonEdit}
                      to={`/app/ancoras-lojas/editar/${rowData.ancoraLojaId}`}
                    >
                      <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                    </Link>
                  )}
                </>
              ),
          },
        ]}
        data={getAncorasLojas}
      />
    ),
    [getAncorasLojas],
  );

  return (
    <>
      <div className={classes.actions}>
        <Button
          variant="contained"
          onClick={() => dispatch(CreatorsAnchors.changeModal({ anchor: 'ancoras-lojas' }))}
          className={classes.button}
        >
          <span>Filtros</span>
        </Button>
        {!visualize && !!findPermission(1216, 'Cadastrar') && (
          <Link className={classes.button} to={`/app/ancoras-lojas/${ancoraId}/cadastrar`}>
            Novo Item
          </Link>
        )}
        {!!anchorFilter.open && (
          <div className={classes.filtersBox}>
            <div className={classes.headFilter}>
              <span className={classes.labelFilter}>Status:</span>
              <button
                className={classes.buttonClose}
                onClick={() => dispatch(CreatorsAnchors.changeModal({ anchor: 'ancoras-lojas' }))}
              >
                <CloseIcon style={{ fontSize: 25, color: '#fff' }} />
              </button>
            </div>

            <select
              onChange={(event) =>
                dispatch(
                  CreatorsAnchors.changeFilter({
                    anchor: 'ancoras-lojas',
                    filter: event.target.value,
                  }),
                )
              }
              value={anchorFilter.filter}
              className={classes.selectStatus}
            >
              <option value="">Todos</option>
              <option value="Ativo">Ativo</option>
              <option value="Inativo">Inativo</option>
            </select>
            <button className={classes.buttonFilter} onClick={() => findAllAncorasLojas()}>
              Aplicar Filtro
            </button>
          </div>
        )}
      </div>

      {memoizedTable}
    </>
  );
}

export default GridAncorasLojas;
